import { getAddonPrice, getStoragePrice, getWorkspaceTypePrice, Pricing } from '@/pages/workgroup/type';
import { WorkspaceT, StorageT } from './type';

// in dollar
export function calculateWorkspacePrice(
  pricing: Pricing,
  platform: string,
  region: string,
  workspace: WorkspaceT,
  cloud_provider: 'BYOC' | 'TGCloud'
): number {
  const computePrice = getWorkspaceTypePrice(
    pricing,
    workspace.workspace_type,
    workspace.enable_ha,
    platform,
    region,
    cloud_provider
  );

  let addPrice = 0;
  if (workspace.enable_insights) {
    addPrice = getAddonPrice(pricing, 'Insights', workspace.workspace_type, platform, region);
  }

  const totalPrice = workspace.hours * workspace.days * (addPrice + computePrice);

  return totalPrice;
}

// in dollar
// because storage price is in dollar not TCR in the pricing data
export function calculateStoragePrice(pricing: Pricing, platform: string, region: string, storage: StorageT): number {
  const unitPrice = getStoragePrice(pricing, platform, region);

  const totalPrice = storage.size * unitPrice;
  return totalPrice;
}

// 1 TCR = $4.00
